import React from 'react';
import { GlobeIcon, ZapIcon, CreditCardIcon, InfinityIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { Countdown } from './Countdown';
import { ScarcityBar } from './ScarcityBar';
type OfferPanelProps = {
  ctaLabel: string;
  showPrice?: boolean;
};
const trust = [{
  icon: ZapIcon,
  label: 'Instant access'
}, {
  icon: CreditCardIcon,
  label: 'One-time payment'
}, {
  icon: InfinityIcon,
  label: 'Lifetime access'
}];
export function OfferPanel({
  ctaLabel,
  showPrice = true
}: OfferPanelProps) {
  return <div className="rounded-3xl border border-electric/30 bg-navy p-5 text-white shadow-[0_30px_60px_-30px_rgba(46,168,255,0.45)] sm:p-8" data-id="element-39" data-mp="2b8yctn3i2suh">
      {showPrice && <div className="mb-6 text-center" data-id="element-40" data-mp="21asgdl0gqex0">
          <p className="text-sm font-semibold text-white/70" data-id="element-41" data-mp="21c3fh7iyqyhs">6 volumes + 5 bonuses · Complete library</p>
          <div className="mt-2 flex items-end justify-center gap-3" data-id="element-42" data-mp="urkdncrafa40">
            <span className="pb-3 text-xl font-bold text-white/45 line-through" data-id="element-43" data-mp="pt94734wn1mb">$436</span>
            <span className="font-display text-7xl font-black leading-none tracking-tight text-white" data-id="element-44" data-mp="2a6m5hlvobcka">$27</span>
            <span className="pb-2 text-sm font-bold text-white/70" data-id="element-45" data-mp="2e6ct5gpwlckl">USD</span>
          </div>
          <p className="mt-2 text-sm font-semibold text-cta" data-id="element-46" data-mp="206bt23hgq966">One-time payment · No subscriptions</p>
        </div>}

      <CTAButton label={ctaLabel} subLabel="Click to get instant access" data-id="element-47" data-mp="258auv8xk0y10" />

      <div className="mt-6" data-id="element-48" data-mp="1qgii94p59y2z">
        <Countdown data-id="element-49" data-mp="1qf7f973iwucx" />
      </div>

      <div className="mt-6 border-t border-white/10 pt-6" data-id="element-50" data-mp="1v8jzz6530h0e">
        <ScarcityBar data-id="element-51" data-mp="1va4w3071o80d" />
      </div>

      <div className="mt-5 flex items-start gap-3 rounded-xl bg-electric/10 p-3.5 text-sm text-white/85" data-id="element-52" data-mp="1hh5g6x3cobsa">
        <GlobeIcon className="mt-0.5 h-5 w-5 shrink-0 text-electric" aria-hidden="true" data-id="element-53" data-mp="1mf6vd6xnnqyh" />
        <p data-id="element-54" data-mp="17ipkegtdoecg">
          <strong className="text-white" data-id="element-55" data-mp="17i63n3fgrw00">Automatic currency conversion.</strong> Pay from any country — the price is
          converted to your local currency automatically at checkout.
        </p>
      </div>

      <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-white/70" data-id="element-56" data-mp="tdz38o31wv04">
        {trust.map(({
        icon: Icon,
        label
      }) => <li key={label} className="flex items-center gap-1.5" data-id="element-57" data-mp="jn462oo9oazw">
            <Icon className="h-4 w-4 text-electric" aria-hidden="true" data-id="element-58" data-mp="jndx8fl1so76" />
            {label}
          </li>)}
      </ul>
    </div>;
}